import sys from '@truckdown/jsclient';
import * as icons from '@truckdown/jsclient/icons';
import * as apis from '@truckdown/jsclient/apis';
import * as locations from '@truckdown/locations';
import { defineComponent, ref, computed, reactive } from 'vue';
import { email, required, helpers } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { ILegacyListingService } from '../Services/ILegacyListingService';
import { AddNoteModel } from '../Services/AddNoteModel';
import { EditNoteModel } from '../Services/EditNoteModel';

sys.fontLibrary.add(icons.solid.faPen);
sys.fontLibrary.add(icons.solid.faTrash);

var setupUserData = function () {
    var ctx = sys.framework.context;

    const isAuth = computed(() => {
        return ctx.isAuthenticated();
    });
    const isAce = computed(() => {
        return ctx.isInRole(apis.framework.SecurityConstants.Roles.FleetUserRole);
    });

    return {
        isAuth,
        isAce
    };
}

export default defineComponent({
    props: {
        listing: {
            type: Object as () => locations.Listing,
            required: true
        }
    },
    setup: function (props, ctx) {
        let listing = props.listing as locations.Listing;

        //add note functionality
        const state = reactive({
            note: '',
            editNote: ''
        })

        const validationRules = {
            note: {
                required: helpers.withMessage('Please provide a note', required)
            },
            editNote: {
                required: helpers.withMessage('A note is required', required)
            }
        };

        const v$ = useVuelidate(validationRules, state)

        const addNote = async function () {
            v$.value.note.$touch();
            const isFormCorrect = !v$.value.note.$invalid;

            if (isFormCorrect) {
                let val = state.note;
                state.note = '';
                v$.value.$reset();

                let service = sys.framework.getRequiredService<ILegacyListingService>('ILegacyListingService');
                let model = new AddNoteModel(
                    listing.id,
                    val
                );
                var res = await service.addNote(model);
                if (res != null) {
                    let note: locations.ListingNote = {
                        id: res._id,
                        comment: res.c,
                        date: res.d,
                        user: res.n,
                        userId: res.uid
                    }
                    notes.value.splice(0, 0, note);
                    sys.events.emit('update-notes', listing.id, notes.value);
                }
            }
        }

        //display notes

        const notes = ref<locations.ListingNote[]>(listing.notes);

        const displayDate = function (dt: Date) {
            return new Date(dt).toLocaleDateString("en-US", {
                weekday: 'short',
                month: 'short',
                day: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        }

        const deleteNote = async function (id: string) {
            let values = notes.value as locations.ListingNote[];

            let note = values.find((note) => note.id == id);

            if (note) {
                var service = sys.framework.getRequiredService<ILegacyListingService>('ILegacyListingService');
                var res = await service.deleteNote(note.id);
                if (res.ok) {
                    notes.value.splice(values.indexOf(note), 1);
                    sys.events.emit('update-notes', listing.id, notes.value);
                }
                //TODO: what to do if not ok
            }
        }

        const editNoteId = ref<string>('');

        const editNote = async function (id: string) {
            let values = notes.value as locations.ListingNote[];
            let note = values.find((note) => note.id == id);

            if (note) {
                state.editNote = note.comment;
                editNoteId.value = id;
            }
        }

        const saveNote = async function (id: string) {
            v$.value.editNote.$touch();
            const isFormCorrect = !v$.value.editNote.$invalid;

            if (isFormCorrect) {
                let val = state.editNote;
                state.editNote = '';

                let values = notes.value as locations.ListingNote[];
                let note = values.find((note) => note.id == id);

                if (note) {


                    var service = sys.framework.getRequiredService<ILegacyListingService>('ILegacyListingService');
                    var model = new EditNoteModel(
                        note.id,
                        val
                    );
                    var res = await service.editNote(model);
                    if (res != null) {
                        note.id = res._id;
                        note.comment = res.c;
                        note.date = res.d;
                        note.user = res.n;
                        note.userId = res.uid;

                        editNoteId.value = '';

                        sys.events.emit('update-notes', listing.id, notes.value);
                    }
                    //TODO: what to do if null
                }
            }
        }

        const cancelNote = function (ev: Event) {
            state.editNote = '';
            editNoteId.value = '';
        }

        const closeForm = function (ev: Event) {
            sys.events.emit('close-listing-form', props.listing.id);
        }

        const moreInfoUrl = computed(() => {
            if (sys.framework.context.sys == 'planrv') {
                return '/shop/features';
            }
            return '/shop/fleets';
        });

        return {
            ...setupUserData(),
            state,
            validationRules,
            v$,
            addNote,
            notes,
            displayDate,
            deleteNote,
            editNoteId,
            editNote,
            saveNote,
            cancelNote,
            closeForm,
            moreInfoUrl
        }
    }
});
